import { useToast } from '@morressier/alembic';

type CopyOptions = {
  successTitle?: string;
  successDescription?: string;
};

export const useCopyToClipboard = (options?: CopyOptions) => {
  const toast = useToast();

  const copy = async (value: string) => {
    try {
      await navigator.clipboard.writeText(value);
      toast({
        variant: 'success',
        title: options?.successTitle ?? 'Copied to clipboard',
        description: options?.successDescription ?? '',
        isClosable: true
      });
    } catch {
      toast({
        variant: 'error',
        title: 'Failed to copy',
        isClosable: true
      });
    }
  };

  return { copy };
};
